import React, { useCallback } from "react";
import styles from "./PickADay.module.css";
import { getMonthDaysList, monthFirstDayShiftList } from "./utils";
import { type Month } from "../../types/date";
import { type DayType, type YearType } from "./types";
import { type Locale } from "./text.i18n";
import { PickADayWeek } from "./PickADayWeek";
import { usePickADayContext } from "./PickADayContext";

interface PickADayMonthProps {
  name: string;
  id: Month;
  year: YearType;
  locale: Locale;
}

const Day: React.FC<{ item: DayType; onClick: (item: DayType) => void }> = ({
  item,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    onClick(item);
  }, [onClick, item]);

  return (
    <div key={item} className={styles.PickADay__day} onClick={handleClick}>
      {item}
    </div>
  );
};

export const PickADayMonth: React.FC<PickADayMonthProps> = ({
  name,
  id,
  year,
  locale,
}) => {
  const { setDay, setMonth } = usePickADayContext();

  const handleClick = useCallback(
    (day: DayType) => {
      setMonth(id);
      setDay(day);
    },
    [setMonth, setDay]
  );

  return (
    <div key={name} className={styles.PickADay__month}>
      <h3 className={styles.PickADay__month_title}>{name}</h3>
      <PickADayWeek locale={locale} />
      {monthFirstDayShiftList(year, id).map((item) => (
        <div key={item} className={styles.PickADay__day} />
      ))}
      {getMonthDaysList(year, id).map((item) => (
        <Day key={item} onClick={handleClick} item={item} />
      ))}
    </div>
  );
};
